import React from 'react';
import './App.css';
import Home from './components/Home.js';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">    
      <Home />
    </div>
  );
}

export default App;
